/* es-restyle 2026-10 (10/10/26), solo con html.es-rs (anteprima ?restyle=1).
   1. etichette in maiuscolo spaziato -> classe .es-rs-lab (testo normale), titoli in maiuscolo -> .es-rs-upper
   2. titoli "a contorno" (testo vuoto con bordo) -> pieni nel blu del brand
   3. home: gli 8 caroselli dei reparti diventano una sezione con schede; prodotti ripetuti tra caroselli nascosti
   4. home: "I piu' venduti della Chandlery" in fascia scura come la fascia approvata */
(function(){
  var H=document.documentElement; if(!H.classList.contains('es-rs')) return;
  var L=(H.lang||'it').slice(0,2);

  function etichette(root){
    var els=(root||document.body).querySelectorAll('span,p,a,button,div,h1,h2,h3,h4,h5,h6,label,small,strong,b,li,summary,dt,em,i');
    for(var i=0;i<els.length;i++){
      var e=els[i]; if(e.dataset.rs) continue;
      var t=''; for(var n=e.firstChild;n;n=n.nextSibling){ if(n.nodeType===3) t+=n.nodeValue; }
      t=t.trim(); if(t.length<2){ continue; }
      e.dataset.rs='1';
      var s=getComputedStyle(e);
      if(s.textTransform==='uppercase'){
        var fs=parseFloat(s.fontSize), big=fs>=20 || /^H[1-3]$/.test(e.tagName) || e.closest('h1,h2,h3');
        e.classList.add(big?'es-rs-upper':'es-rs-lab');
      }
      if(parseFloat(s.webkitTextStrokeWidth)>0 || s.webkitTextFillColor==='rgba(0, 0, 0, 0)' || (s.color==='rgba(0, 0, 0, 0)' && t)) e.classList.add('es-rs-outline');
    }
  }

  // "195,00 € EUR" -> "195,00 €": il codice valuta ripete il simbolo
  var SYM={EUR:'€',USD:'$',GBP:'£'};
  // pulsanti scritti in maiuscolo nel testo: "AGGIUNGI TUTTO" -> "Aggiungi tutto"
  function frasi(){
    document.querySelectorAll('.es-fbt-add,.esb__badge,.esh__cta').forEach(function(e){
      if(e.childElementCount||e.dataset.rsf) return; var t=e.textContent.trim();
      if(t.length>3 && t===t.toUpperCase() && /[A-ZÀ-Ý]{3}/.test(t)){ e.textContent=t.charAt(0)+t.slice(1).toLowerCase(); }
      e.dataset.rsf='1';
    });
  }
  function valuta(){
    document.querySelectorAll('.money, sale-price, compare-at-price, .price, [class*="price"] span').forEach(function(e){
      if(e.childElementCount) return;
      var t=e.textContent, m=t.match(/^(.*\d.*?)\s+(EUR|USD|GBP)\s*$/);
      if(m && m[1].indexOf(SYM[m[2]])>-1) e.textContent=m[1].trim();
    });
  }

  function reparti(){
    var ids=['v3_ormeggio','v3_pulizia','v3_invernaggio','v3_manutenzione','v3_elettrico','v3_sicurezza','v3_abbigliamento','v3_navigazione'];
    var secs=ids.map(function(id){ return document.querySelector('[id$="__'+id+'"]'); }).filter(Boolean);
    if(secs.length<2) return;
    var T={it:'Esplora per reparto',en:'Shop by department',de:'Nach Bereich einkaufen',fr:'Acheter par rayon',es:'Comprar por sección',nl:'Winkel per afdeling',pt:'Comprar por secção',sv:'Handla per avdelning'};
    var box=document.createElement('div'); box.className='es-rs-tabs';
    box.innerHTML='<h2></h2><div class="es-rs-tabs__bar" role="tablist"></div>';
    box.querySelector('h2').textContent=T[L]||T.en;
    var bar=box.querySelector('.es-rs-tabs__bar');
    secs[0].parentNode.insertBefore(box,secs[0]);
    secs.forEach(function(s,i){
      s.classList.add('es-rs-dept'); if(i===0) s.classList.add('is-on');
      var h=s.querySelector('.esv__h2,.esv__h'); var name=h?h.textContent.trim():('#'+(i+1));
      var b=document.createElement('button'); b.type='button'; b.className='es-rs-tab'+(i===0?' is-on':''); b.setAttribute('role','tab'); b.textContent=name;
      b.onclick=function(){
        secs.forEach(function(x){ x.classList.toggle('is-on',x===s); });
        bar.querySelectorAll('.es-rs-tab').forEach(function(x){ x.classList.toggle('is-on',x===b); });
        var trk=s.querySelector('.esv__trk'); if(trk) trk.scrollLeft=0;
        b.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'});
      };
      bar.appendChild(b);
    });
  }

  function doppioni(){
    var seen={};
    document.querySelectorAll('.esv__trk').forEach(function(trk){
      var cards=[].slice.call(trk.querySelectorAll('a.esv__card')), visibili=cards.length;
      cards.forEach(function(c){
        var k=(c.getAttribute('href')||'').split('?')[0].replace(/^\/[a-z]{2}(-[a-z]{2})?\//,'/');
        if(seen[k] && visibili>4){ c.classList.add('es-rs-dup'); visibili--; }
        seen[k]=1;
      });
    });
  }

  // marca "easysea" sulle card dei prodotti easysea: ripete il nome del sito
  function marche(){ document.querySelectorAll('.esv__brand,product-card a.text-xs').forEach(function(e){ if(e.textContent.trim().toLowerCase()==='easysea') e.style.display='none'; }); }


  // recensioni della home: prima quelle nella lingua della pagina, poi l'inglese, poi le altre; via quelle con critiche o fuori tema
  var STOP={it:/\b(il|lo|la|gli|che|per|di|con|sono|molto|ottim[oa]|prodotto|non|è)\b/gi,en:/\b(the|and|it|is|my|very|for|with|love|great|they|to|of)\b/gi,
    de:/\b(und|der|die|das|ist|sehr|nicht|mit|für|ich)\b/gi,fr:/\b(le|la|les|et|est|très|pour|avec|nous|des)\b/gi,es:/\b(el|los|las|y|es|muy|para|con|estamos|que|me)\b/gi,
    nl:/\b(de|het|een|en|is|zeer|heel|voor|met|wij)\b/gi,pt:/\b(o|os|as|e|é|muito|para|com|não|que)\b/gi,sv:/\b(och|det|är|en|för|med|mycket|jag|vi)\b/gi};
  var DEBOLI=['Jan E.','Fiona C.','T. D.','Ned H.','Jade M.'];
  function lingua(t){ var best='en',n=0; for(var k in STOP){ var m=(t.match(STOP[k])||[]).length; if(m>n){n=m;best=k;} } return best; }
  function recensioni(){
    document.querySelectorAll('.esv__trk').forEach(function(trk){
      var cards=[].slice.call(trk.querySelectorAll(':scope>.esv__rcard')); if(!cards.length||trk.dataset.rsr) return; trk.dataset.rsr='1';
      var rank=function(c){ var l=lingua((c.querySelector('.esv__rtxt')||c).textContent); return l===L?0:(l==='en'?1:2); };
      cards.forEach(function(c){ var b=c.querySelector('.esv__rwho b'); if(b&&DEBOLI.indexOf(b.textContent.trim())>-1) c.classList.add('es-rs-weak'); c._r=rank(c); });
      cards.map(function(c,i){return {c:c,i:i};}).sort(function(a,b){return (a.c._r-b.c._r)||(a.i-b.i);}).forEach(function(o){ trk.appendChild(o.c); });
      trk.querySelectorAll(':scope>.esv__rcard:not(.es-rs-weak) img').forEach(function(im,i){ if(i<3) im.loading='eager'; });
      trk.style.scrollSnapType='none'; trk.scrollLeft=0; requestAnimationFrame(function(){ trk.scrollLeft=0; trk.style.scrollSnapType=''; });
    });
  }


  // credito "immagini Osculati" solo sui prodotti Osculati
  function crediti(){ var c=document.querySelector('.cha__credit'); if(!c||c.dataset.rsc) return; c.dataset.rsc='1';
    var marca='', k=[].slice.call(document.querySelectorAll('.cha *')).filter(function(e){ return !e.children.length && /^(Marca|Brand|Marke|Marque|Merk|Märke)$/.test(e.textContent.trim()); })[0];
    if(k){ var v=k.nextElementSibling||(k.parentElement&&k.parentElement.nextElementSibling); marca=v?v.textContent.trim():''; }
    if(marca && !/osculati/i.test(marca)) c.style.display='none'; }

  function scure(){
    var s=document.querySelector('[id$="__v3_best"]'); if(s) s.classList.add('es-rs-dark');
  }

  function avvio(){
    try{ doppioni(); reparti(); scure(); recensioni(); }catch(e){}
    var go=function(){ try{ etichette(); valuta(); frasi(); marche(); crediti(); }catch(e){} };
    setTimeout(go,250);
    // carrello a cassetto e contenuti caricati dopo: ricontrollo leggero
    var timer=null;
    new MutationObserver(function(){ clearTimeout(timer); timer=setTimeout(go,400); }).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',avvio); else avvio();
})();

/* 23/10/26 video della home: niente autoplay nel markup (il browser li scaricava tutti subito, 14 MB da telefono).
   Partono quando arrivano a 400px dallo schermo e si fermano quando escono. */
(function(){var vs=document.querySelectorAll('video[data-es-lazyplay]');if(!vs.length)return;
 if(!('IntersectionObserver' in window)){vs.forEach(function(v){v.preload='auto';v.play&&v.play().catch(function(){})});return}
 var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;
  if(e.isIntersecting){if(v.preload!=='auto')v.preload='auto';var p=v.play();if(p&&p.catch)p.catch(function(){})}else if(!v.paused)v.pause()})},{rootMargin:'400px 0px'});
 vs.forEach(function(v){io.observe(v)})})();
